<template>
  <div class="home" v-if="homeData.map">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="item in homeData.bannerList"
          :key="item.id"
        >
          <img :src="item.picture" alt="图片" />
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
    </div>
    <div class="news">
      <div class="middleContent">
        <div class="left">
          <div class="title">
            <div class="nav">
              <p
                @click="swiperTo(0)"
                :class="activeNewsIndex === 0 ? 'active' : ''"
                :to="{ name: 'Home' }"
              >
                通知公告
              </p>
              <span>/</span>
              <p
                @click="swiperTo(1)"
                :class="activeNewsIndex === 1 ? 'active' : ''"
                :to="{ name: 'Home' }"
              >
                新闻动态
              </p>
              <span>/</span>
              <p
                @click="swiperTo(2)"
                :class="activeNewsIndex === 2 ? 'active' : ''"
                :to="{ name: 'Home' }"
              >
                行业资讯
              </p>
            </div>
            <router-link :to="{ name: 'News' }"
              ><img src="@/assets/arrow1.png" alt="更多"
            /></router-link>
          </div>
          <div class="swiper-container-news">
            <div class="swiper-wrapper">
              <router-link
                tag="div"
                :to="{ name: 'NewsXq', params: { id: homeData.map.notice.id } }"
                class="swiper-slide public"
              >
                <p class="tit overhid">
                  <img src="@/assets/icon.png" alt="图标" />
                  {{ homeData.map.notice.title }}
                </p>
                <p class="con overhid4">{{ homeData.map.notice.subTitle }}</p>
                <p class="date">{{ homeData.map.notice.createTime }}</p>
              </router-link>
              <div class="swiper-slide newsinfo">
                <router-link
                  tag="div"
                  :to="{
                    name: 'NewsXq',
                    params: { id: homeData.map.new.newObj.id }
                  }"
                  class="top"
                >
                  <div class="img">
                    <img :src="homeData.map.new.newObj.image" alt="图片" />
                  </div>
                  <div class="font">
                    <p class="title">{{ homeData.map.new.newObj.title }}</p>
                    <p class="desc overhid3">
                      {{ homeData.map.new.newObj.subTitle }}
                    </p>
                  </div>
                </router-link>
                <ul class="bottom">
                  <router-link
                    tag="li"
                    :to="{ name: 'NewsXq', params: { id: item.id } }"
                    v-for="item in homeData.map.new.newList"
                    :key="item.id"
                  >
                    <p class="left overhid">{{ item.title }}</p>
                    <p class="right">{{ item.createTime }}</p>
                  </router-link>
                </ul>
              </div>
              <div class="swiper-slide newsinfo">
                <router-link
                  tag="div"
                  :to="{
                    name: 'NewsXq',
                    params: { id: homeData.map.info.infoObj.id }
                  }"
                  class="top"
                >
                  <div class="img">
                    <img :src="homeData.map.info.infoObj.image" alt="图片" />
                  </div>
                  <div class="font">
                    <p class="title">{{ homeData.map.info.infoObj.title }}</p>
                    <p class="desc overhid3">
                      {{ homeData.map.info.infoObj.subTitle }}
                    </p>
                  </div>
                </router-link>
                <ul class="bottom">
                  <router-link
                    tag="li"
                    :to="{ name: 'NewsXq', params: { id: item.id } }"
                    v-for="item in homeData.map.info.infoList"
                    :key="item.id"
                  >
                    <p class="left overhid">{{ item.title }}</p>
                    <p class="right">{{ item.createTime }}</p>
                  </router-link>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="rightimg" v-if="homeData.healthDTO">
          <div class="left">
            <router-link
              tag="div"
              :to="{ name: 'EncyclopediaList', params: { type: 1 } }"
              class="img"
            >
              <img :src="homeData.healthDTO.healthAre.image" alt="图片" />
              <p>{{ homeData.healthDTO.healthAre.subTitle }}</p>
            </router-link>
            <router-link
              tag="div"
              :to="{ name: 'EncyclopediaList', params: { type: 2 } }"
              class="img"
            >
              <img :src="homeData.healthDTO.mentalHealth.image" alt="图片" />
              <p>{{ homeData.healthDTO.mentalHealth.subTitle }}</p>
            </router-link>
          </div>
          <div class="right">
            <router-link
              tag="div"
              :to="{ name: 'EncyclopediaList', params: { type: 3 } }"
              class="img"
            >
              <img :src="homeData.healthDTO.oldAge.image" alt="图片" />
              <p>{{ homeData.healthDTO.oldAge.subTitle }}</p>
            </router-link>
            <router-link
              tag="div"
              :to="{ name: 'EncyclopediaList', params: { type: 4 } }"
              class="img"
            >
              <img :src="homeData.healthDTO.workOut.image" alt="图片" />
              <p>{{ homeData.healthDTO.workOut.subTitle }}</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="mechanism">
      <div class="swiper-container-history">
        <div class="info">
          <div class="con">
            <p class="tit">养老机构信息</p>
            <div class="line"></div>
            <p class="text">{{ homeData.nursingHomes.text.text }}</p>
          </div>
        </div>
        <div class="swiper-wrapper">
          <router-link
            tag="div"
            :to="{ name: 'DepartmentXq', params: { id: item.id } }"
            class="swiper-slide"
            v-for="item in homeData.nursingHomes.bannerList"
            :key="item.id"
          >
            <img :src="item.image" alt="图片" />
            <div class="shadow">
              <p>{{ item.title }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="mechanism" style="margin-top: 150px;">
      <div class="swiper-container-history">
        <div class="info">
          <div class="con">
            <p class="tit">老年食堂信息</p>
            <div class="line"></div>
            <p class="text">{{ homeData.canteens.canteen.text }}</p>
          </div>
        </div>
        <div class="swiper-wrapper">
          <router-link
            tag="div"
            :to="{ name: 'DepartmentXq', params: { id: item.id } }"
            class="swiper-slide"
            v-for="item in homeData.canteens.canteenList"
            :key="item.id"
          >
            <img :src="item.image" alt="图片" />
            <div class="shadow">
              <p>{{ item.title }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="code">
      <div class="leftfont">
        <p class="ch">扫一扫关注</p>
        <p class="en">CONTACT</p>
      </div>
      <img
        src="https://www.yueyilan.com/img-yueyilan/upload/photo/yyl/code.jpg"
        alt="图片"
      />
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import api from "@/api/api";
export default {
  name: "Home",
  data() {
    return {
      activeNewsIndex: 0, //当前显示的新闻
      bannerSwiper: null, //banner
      newsSwiper: null, //新闻
      mechanismSwiper: null, //下属机构
      homeData: {}
    };
  },
  methods: {
    swiperTo(index) {
      this.activeNewsIndex = index;
      this.newsSwiper.slideTo(index, 1000, false);
    },
    upDateSwiper() {
      let that = this;
      this.bannerSwiper = new Swiper(".swiper-container", {
        // 如果需要分页器
        pagination: ".swiper-pagination",
        paginationClickable: true,
        autoplay: 3000,
        loop: true
      });
      this.newsSwiper = new Swiper(".swiper-container-news", {
        onSlideChangeEnd: function(swiper) {
          that.activeNewsIndex = Number(swiper.activeIndex);
        }
      });
      this.mechanismSwiper = new Swiper(".swiper-container-history", {
        autoplay: 1,
        speed: 6000,
        freeMode: true,
        stopOnLastSlide: false,
        disableOnInteraction: true,
        // loop: true,
        observer: true,
        obserParents: true,
        slidesPerView: "auto",
        breakpoints: {
          //当宽度小于等于320
          768: {
            slidesPerView: 1
          },
          //当宽度小于等于480
          1200: {
            slidesPerView: 2
          }
        }
      });
    }
  },
  created() {
    api.getHome().then(res => {
      console.log("首页", res);
      if (res.data.code === 0) {
        this.homeData = res.data.data.home;
        this.$nextTick(function() {
          this.upDateSwiper();
        });
      } else {
        this.$message({
          center: true,
          type: "error",
          message: res.data.msg,
          duration: 1000
        });
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.home {
  background-color: #fff;
  .swiper-container {
    width: 100%;
    height: 440px;
    .swiper-slide {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        height: 100%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .news {
    width: 100%;
    background: url("https://www.yueyilan.com/static/img/bg.15d8eed.png")
      no-repeat center;
    background-size: cover;
    padding-bottom: 106px;
    .middleContent {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      .left {
        width: 48%;
        .title {
          width: 100%;
          justify-content: space-between;
          display: flex;
          font-size: 20px;
          line-height: 20px;
          border-bottom: 1px solid #e5e5e5;
          .nav {
            display: flex;
            p {
              padding-bottom: 16px;
              cursor: pointer;
            }
            p.active {
              border-bottom: 2px solid #fab51d;
            }
            span {
              margin: 0 16px;
              color: #c0c4cc;
            }
          }
          img {
            width: 16px;
            height: 16px;
            cursor: pointer;
          }
        }
        .swiper-container-news {
          width: 100%;
          margin-top: 24px;
          overflow: hidden;
          .swiper-slide {
            width: 100%;
            box-sizing: border-box;
            .tit {
              font-size: 20px;
              color: #303133;
              line-height: 28px;
              font-weight: bold;
            }
            .con {
              font-size: 18px;
              color: #303133;
              line-height: 32px;
              margin-top: 32px;
            }
            .date {
              font-size: 16px;
              margin-top: 32px;
              color: #606266;
            }
            .top {
              width: 100%;
              display: flex;
              justify-content: space-between;
              padding-bottom: 24px;
              border-bottom: 1px solid #cccccc;
              cursor: pointer;
              .img {
                width: 30%;
                flex-shrink: 0;
                margin-right: 24px;
                img {
                  width: 100%;
                }
              }
              .font {
                width: 20px;
                flex-grow: 1;
                .title {
                  font-size: 20px;
                  line-height: 28px;
                  border: 0;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  display: block;
                  font-weight: bold;
                }
                .desc {
                  font-size: 16px;
                  line-height: 24px;
                  margin-top: 12px;
                }
              }
            }
            .bottom {
              width: 100%;
              li {
                width: 100%;
                line-height: 28px;
                font-size: 16px;
                display: flex;
                justify-content: space-between;
                margin-top: 16px;
                cursor: pointer;
                transition: color 0.3s ease-out;
                .left {
                  width: calc(100% - 90px);
                }
                &:hover {
                  color: #1797e0;
                }
              }
            }
          }
          .swiper-slide.public {
            background-color: #fff;
            cursor: pointer;
            padding: 24px;
            height: 100%;
            .tit {
              img {
                width: 20px;
                height: 20px;
                margin-right: 12px;
              }
            }
          }
        }
      }
      .rightimg {
        width: 40%;
        display: flex;
        justify-content: space-between;
        .left,
        .right {
          width: 60.2%;
          .img {
            width: 100%;
            margin-bottom: 12px;
            position: relative;
            cursor: pointer;
            overflow: hidden;
            img {
              width: 100%;
              transition: 0.3s ease-out;
            }
            &:hover {
              img {
                transform: scale(1.1);
              }
            }
          }
          .img:last-child {
            margin-bottom: 0;
          }
          p {
            position: absolute;
            font-size: 24px;
            color: #fff;
            left: 20px;
            top: 32px;
            font-weight: bold;
          }
        }
        .right {
          width: 37.8%;
        }
      }
    }
  }
  .mechanism {
    width: 100%;
    position: relative;
    .swiper-container-history {
      width: 100%;
      height: 100%;
      overflow: hidden;
      .swiper-wrapper {
        .swiper-slide {
          width: 524px;
          height: 350px;
          position: relative;
          cursor: pointer;
          img {
            width: 100%;
          }
          .shadow {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background-image: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0),
              rgba(0, 0, 0, 0.5)
            );
            p {
              position: absolute;
              font-size: 24px;
              line-height: 40px;
              left: 28px;
              bottom: 28px;
              color: #fff;
            }
          }
        }
      }
    }
    .info {
      width: 286px;
      height: 444px;
      background-color: #1797e0;
      box-sizing: border-box;
      padding: 24px 30px;
      position: absolute;
      left: calc(50% - 600px);
      top: 50%;
      transform: translateY(-50%);
      z-index: 1000;
      .con {
        width: 100%;
        color: #fff;
        .tit {
          font-size: 32px;
          line-height: 32px;
          font-weight: bold;
        }
        .line {
          width: 24px;
          height: 2px;
          background-color: #fff;
          margin-top: 16px;
          margin-bottom: 32px;
        }
        .text {
          font-size: 16px;
          line-height: 32px;
          height: 160px;
        }
      }
    }
  }
  .code {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .leftfont {
      .ch {
        color: #606266;
        font-size: 22px;
      }
      .en {
        font-size: 32px;
        color: #303133;
        font-weight: bold;
        margin-top: 12px;
      }
    }
    img {
      width: 215px;
    }
  }
}
@media screen and (max-width: 1200px) {
  .home .swiper-container {
    height: 278px;
  }
  .home .code {
    width: 100%;
    box-sizing: border-box;
    padding: 30px 24px;
  }

  .home .news .middleContent {
    .left {
      .title {
        font-size: 16px;
      }
      .swiper-container-news {
        .public {
          .tit {
            font-size: 18px;
          }
          .con {
            margin-top: 28px;
            line-height: 28px;
            font-size: 16px;
          }
          .date {
            margin-top: 28px;
            font-size: 14px;
          }
        }
        .swiper-slide {
          .top {
            .font {
              .title {
                font-size: 18px;
              }
              .desc {
                font-size: 14px;
                -webkit-line-clamp: 2;
              }
            }
          }
          .bottom {
            li {
              line-height: 24px;
              margin-top: 10px;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .home .mechanism .info {
    width: 30%;
    height: 130%;
    padding: 16px;
    left: 24px;
    .con {
      .tit {
        font-size: 26px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .home .swiper-container {
    height: 178px;
  }
  .home .news {
    padding-bottom: 44px;
  }
  .home .news .middleContent {
    margin-top: 24px;
    display: block;
    .left {
      width: 100%;
      margin-right: 0;
      margin-bottom: 42px;
      .swiper-container-news {
        .public.swiper-slide {
          padding: 16px;
          padding-top: 0;
        }
        .newsinfo {
          .bottom {
            .left {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .rightimg {
      width: 100%;
      .left,
      .right {
        margin-bottom: 0;
        .img {
          margin-bottom: 8px;
          p {
            font-size: 20px;
            top: 12px;
            left: 12px;
          }
        }
      }
    }
  }
  .home .mechanism .info {
    transform: translateY(0);
    width: 100%;
    height: auto;
    left: 0;
    padding-bottom: 24px;
    position: relative;
    .con {
      .tit {
        font-size: 22px;
      }
      .text {
        height: auto;
        width: 100%;
        font-size: 14px;
        line-height: 28px;
      }
    }
  }
  .home
    .mechanism
    .swiper-container-history
    .swiper-wrapper
    .swiper-slide
    .shadow
    p {
    font-size: 22px;
    left: 20px;
    bottom: 20px;
  }
  .home .code {
    padding: 24px 16px;
    .leftfont {
      .ch {
        font-size: 16px;
      }
      .en {
        font-size: 24px;
      }
    }
    img {
      width: 160px;
    }
  }
}
</style>
<style>
.home .swiper-pagination-bullet {
  border-radius: 4px !important;
  transition: width 0.3s ease-out;
}
.home .swiper-pagination-bullet-active {
  width: 30px !important;
}
.swiper-container-free-mode > .swiper-wrapper {
  -webkit-transition-timing-function: linear !important; /*之前是ease-out*/
  -moz-transition-timing-function: linear !important;
  -ms-transition-timing-function: linear !important;
  -o-transition-timing-function: linear !important;
  transition-timing-function: linear !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue